import { ds_AccordionBlock_Entry } from './AccordionBlock'
import { ds_AthleticsCalendarBlock_Entry } from './AthleticsCalendarBlock'
import { ds_ButtonGroupBlock_Entry } from './ButtonGroupBlock'
import { ds_DividerBlock_Entry } from './DividerBlock'
import { ds_EventsCalendarBlock_Entry } from './EventsCalendarBlock'
import { ds_EventsListingBlock_Entry } from './EventsListingBlock'
import { ds_FeatureTilesBlock_Entry } from './FeatureTilesBlock'
import { ds_FormBlock_Entry } from './FormBlock'
import { ds_GalleryBlock_Entry } from './GalleryBlock'
import { ds_ImageAccordionBlock_Entry } from './ImageAccordionBlock'
import { ds_ImageAndLinksColumnsBlock_Entry } from './ImageAndLinksColumnsBlock'
import { ds_ImageAndTextAccordionBlock_Entry } from './ImageAndTextAccordionBlock'
import { ds_ImagesBlock_Entry } from './ImagesBlock'
import { ds_LinksBlock_Entry } from './LinksBlock'
import { ds_NewsListingBlock_Entry } from './NewsListingBlock'
import { ds_NewsIntegrationListingBlock_Entry } from './NewsIntegrationListingBlock'
import { ds_NewsletterListingBlock_Entry } from './NewsletterListingBlock'
import { ds_QuoteBlock_Entry } from './QuoteBlock'
import { ds_RichTextBlock_Entry } from './RichTextBlock'
import { ds_SocialMediaFeedBlock_Entry } from './SocialMediaFeedBlock'
import { ds_StaffDirectoryBlock_Entry } from './StaffDirectoryBlock'
import { ds_TableBlock_Entry } from './TableBlock'
import { ds_TabsBlock_Entry } from './TabsBlock'
import { ds_TilesBlock_Entry } from './TilesBlock'
import { ds_VideoBlock_Entry } from './VideoBlock'
import { ds_LayoutBlock_Entry } from './LayoutBlock'
import { ds_EmbedBlock_Entry } from './EmbedBlock'
import { ds_BusinessDirectoryBlock_Entry } from './BusinessDirectoryBlock'
import { ds_AthleticsFixturesBlock_Entry } from './AthleticsFixturesBlock'
import { ds_AthleticsRosterBlock_Entry } from './AthleticsRosterBlock'

export default {
    ds_AccordionBlock_Entry,
    ds_AthleticsCalendarBlock_Entry,
    ds_ButtonGroupBlock_Entry,
    ds_DividerBlock_Entry,
    ds_EventsCalendarBlock_Entry,
    ds_EventsListingBlock_Entry,
    ds_FeatureTilesBlock_Entry,
    ds_FormBlock_Entry,
    ds_GalleryBlock_Entry,
    ds_ImageAndLinksColumnsBlock_Entry,
    ds_ImageAccordionBlock_Entry,
    ds_ImageAndTextAccordionBlock_Entry,
    ds_ImagesBlock_Entry,
    ds_LinksBlock_Entry,
    ds_SocialMediaFeedBlock_Entry,
    ds_NewsListingBlock_Entry,
    ds_NewsIntegrationListingBlock_Entry,
    ds_NewsletterListingBlock_Entry,
    ds_QuoteBlock_Entry,
    ds_RichTextBlock_Entry,
    ds_StaffDirectoryBlock_Entry,
    ds_TableBlock_Entry,
    ds_TabsBlock_Entry,
    ds_TilesBlock_Entry,
    ds_VideoBlock_Entry,
    ds_LayoutBlock_Entry,
    ds_EmbedBlock_Entry,
    ds_BusinessDirectoryBlock_Entry,
    ds_AthleticsFixturesBlock_Entry,
    ds_AthleticsRosterBlock_Entry,
}